module.exports = __webpack_public_path__ + "static/images/calendar-blue.01839ba5aeb780afc0db14ae18f7adcb.svg";